export default __webpack_public_path__ + "static/media/timesheet_active.a5e398e2.svg";